// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Jf7o","modalForm":"UpgradeEpcsModal_modalForm__1Ryck","modalFooter":"UpgradeEpcsModal_modalFooter__1lsIH"};